import { Navigate, useLocation } from "react-router-dom";

/** A redirect that carries the query along: a bare <Navigate to> drops it (e.g. /home/?invite=). */
const RedirectKeepQuery = ({ to }: { to: string }) => {
	const { search, hash } = useLocation();
	return <Navigate to={{ pathname: to, search, hash }} replace />;
};

export default RedirectKeepQuery;
